import React, { useEffect, useRef, useState } from 'react';
import ReplayIcon from '@mui/icons-material/Replay';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CloseIcon from '@mui/icons-material/Close';

import Box from '@mui/material/Box';
import Calendar from 'react-calendar'; // Import the calendar component
import 'react-calendar/dist/Calendar.css'; // Import the calendar styles
import { useDispatch, useSelector } from 'react-redux';
import { formatDateToYMD } from 'utils/date';
import { decodeTimeToISO } from 'utils/date';
import { setSavedload, setProviders, setVisittype, clearPersistedData } from "../../redux/store"
import { parseISO, startOfDay } from 'date-fns'; // Import from date-fns
import { toZonedTime } from 'date-fns-tz'; // Only if you need this for timezone
import { Chip, Stack, Tooltip } from '@mui/material';
import useModalStore from 'zustand/zustandstore';
import { DateRange } from 'react-date-range';
import calenderv2 from '../../assets/calenderv2.png'
import filterv2 from '../../assets/filterv2.png'
import { ClearIcon } from '@mui/x-date-pickers';
import { formatChipDate2 } from 'utils/date';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import CalendarModal from './calendermodal';
import FiltersModal from './filtermodal';
const storedDate=(x)=>{  
  let normaldate=[{
    startDate: new Date(),
    endDate: new Date(), 
    key: "selection",
  }]
   const dateFilter = x?.filter_array?.date_filter;   
   if (!dateFilter || !dateFilter.start_date || !dateFilter.end_date) {  

    return normaldate
  }else{

   let changed=[{
    startDate: startOfDay(parseISO(dateFilter.start_date)), // Use parseISO from date-fns
    endDate: startOfDay(parseISO(dateFilter.end_date)), 
    key: "selection",
  }]
    return changed
  }
}
const formatChipDate = (date) => {
  // Check if the input is a valid Date
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    return false; // Return false for invalid dates
  }

  // Convert the date to the desired timezone
  const timezone = 'Asia/Kolkata'; // Adjust the timezone as needed
  const zonedDate = toZonedTime(date, timezone);
  const today = toZonedTime(new Date(), timezone); // Get today's date in the same timezone

  // Normalize both dates to remove time components
  const isSameDay = zonedDate.getFullYear() === today.getFullYear() &&
    zonedDate.getMonth() === today.getMonth() &&
    zonedDate.getDate() === today.getDate();

  if (isSameDay) {
    return false; // Return false if the date is today
  }

  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  const dayOfMonth = zonedDate.getDate();
  const month = months[zonedDate.getMonth()];
  const year = zonedDate.getFullYear();

  // Format the date as "2 Sep, 2024"
  return `${dayOfMonth} ${month.slice(0, 3)}, ${year}`; // Shortened month name
};
const convertTimeToValue = (timeString) => {
    if(!timeString){
      return 420
    }
    // Extract hours and minutes from the time string
    const timeParts = timeString.split(':');
    const hours = parseInt(timeParts[0], 10);
    const minutes = parseInt(timeParts[1], 10);
  
    // Convert to total minutes
    return hours * 60 + minutes;
  };
const Filtersdt = ({handletimeStamp,filteredData,originaldata,tab,setTab,fetchEhr,handleTabs,handleRecordType}) => {
     const savedload = useSelector((state) => state.data.savedload);
       const provid = useSelector((state) => state.settings.providers);
       const vis=useSelector((state)=> state.settings.visittype)
     const [showDatePicker, setShowDatePicker] = useState(false);
      const [value, setValue] = useState([420, 1140]);
      const [newdatepicker,setNewDatePicker]=useState(false)
      const [uniqueVisitType,SetUniqueVisitType]=useState([])
          const[uniqueProvider,setUniqueProvider]=useState([])
       const [datestate, setdateState] = useState(storedDate(savedload));
       const [hoverCustomDate, setHoverCustomDate] = useState(false);
     
           const [showFilterModal, setShowFilterModal] = useState(false); // State for filter modal
       const [selectedCustomDate, setSelectedCustomDate] = useState(null);
const [showCalendar, setShowCalendar] = useState(false);
    const [selectedProviders, setSelectedProviders] = useState(provid && provid.length ? provid : []);
    const [selectedVisits, setSelectedVisits] = useState(vis&&vis.length?vis:[]); 
       const [disableLi, setDisableLi] = useState([])
        const [dateRange, setDateRange] = useState([
           {
             startDate: new Date(),
             endDate: new Date(),
             key: "selection",
           },
         ]);
       const dropdownRef = useRef(null);
    const dispatch = useDispatch();
    // const formatDate = (date) => {
    //     const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    //     const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    //     const day = days[date.getDay()];
    //     const dayOfMonth = date.getDate();
    //     const month = months[date.getMonth()];
    //     return `${day}, ${dayOfMonth} ${month}`;
    // };
    const handleFilterClick = () => {
      setShowFilterModal(!showFilterModal);
  };
  

  const filterOnCloseHandler = () => {
      setShowFilterModal(false);
  };
    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    };

    
  const options = [
    { label: 'All Patients', value: 'ALL' },
    { label: 'Pending', value: 'PENDING' },
    { label: 'Completed', value: 'COMPLETED' }
  ];
 const mydata=useModalStore()
const handleOnDateSelector=(x)=>{
  let normaldate=[{
    startDate: new Date(),
    endDate: new Date(), 
    key: "selection",
  }]
normaldate[0].startDate=x;
normaldate[0].endDate=x 
setdateState(normaldate) 
handletimeStamp({
  startDate:formatDateToYMD(x),
  endDate:formatDateToYMD(x),
  startTime:decodeTimeToISO(value[0]),
  endTime:decodeTimeToISO(value[1])
 })

 setShowDatePicker(false);

}
const handleproviderchipDelete = (x) => {
  setSelectedProviders((prevProviders) => {
    const updatedProviders = prevProviders.filter(provider => provider !== x);
    handleRecordType(updatedProviders, selectedVisits, true);
    return updatedProviders; // Update the state with the new array
  });
};
const handleProviderClick = (provider) => {
  setSelectedProviders((prev) =>
    prev.includes(provider)
      ? prev.filter((item) => item !== provider) 
      : [...prev, provider] 
  );
};
 const handleDateChip = () => {
    const today = new Date();
    const localOffset = today.getTimezoneOffset() * 60000; // Offset in milliseconds
    const localDate = new Date(today - localOffset).toISOString().split("T")[0];
  
    handletimeStamp({
      startDate: localDate,
      endDate: localDate,
      startTime: decodeTimeToISO(value[0]),
      endTime: decodeTimeToISO(value[1]),
    });
  };
  const handleOnclear = () => {
      // dispatch(setProviders([]))
      // dispatch(setVisittype([]))  
      clearPersistedData();
      // handletimeStamp({
      //   startDate:new Date().toISOString().split("T")[0],
      //   endDate: new Date().toISOString().split("T")[0],
      //   startTime: decodeTimeToISO(value[0]),
      //   endTime: decodeTimeToISO(value[1]),
      // });
      window.location.reload()
      //  fetchDashBoardData()
    }
const handleVisitschipDelete = (x) => {

  const updatedVisits = selectedVisits.filter(visits => visits !== x);
  setSelectedVisits(updatedVisits)
  handleRecordType(selectedProviders, updatedVisits, true);

};
const handleVisitClick = (visit) => {
  setSelectedVisits((prev) =>
    prev.includes(visit)
      ? prev.filter((item) => item !== visit) 
      : [...prev, visit] 
  );
};
  const handleClear=()=>{
    dispatch(setProviders([]))
    dispatch(setVisittype([]))
    setSelectedVisits([])
    setSelectedProviders([])
    handletimeStamp({
      startDate:formatDateToYMD(datestate[0].startDate),
      endDate:formatDateToYMD(datestate[0].endDate),
      startTime:decodeTimeToISO(value[0]),
      endTime:decodeTimeToISO(value[1])
     })
  }
const handledateChange = (value) => {
  console.log(value)
  setdateState(value);
};
    // useEffect(()=>{
    //     if(savedload.filter_array?.date_filter.start_time){
    //      setValue([convertTimeToValue(savedload.filter_array?.date_filter.start_time),convertTimeToValue(savedload.filter_array?.date_filter.end_time)])
    //     }       
    
    //   },[savedload])
       
    const changeDate = (days) => { 
      const newDate = new Date(datestate[0].startDate);
        newDate.setDate(newDate.getDate() + days);
        let normaldate=[{
          startDate: new Date(),
          endDate: new Date(), 
          key: "selection",
        }]
      normaldate[0].startDate=newDate;
      normaldate[0].endDate=newDate;        
        setdateState(normaldate)
        handletimeStamp({
          startDate:formatDateToYMD(newDate),
          endDate:formatDateToYMD(newDate),
          startTime:decodeTimeToISO(value[0]),
          endTime:decodeTimeToISO(value[1])
         })
      
    };
    const handleDateSelection = (item) => {
      const today = new Date();
      let startDate, endDate;
      switch (item) {
        case "Today":
          // Set both start and end dates to today
          startDate = new Date(today);
          endDate = new Date(today);
          break;
        case "Yesterday":
          // Set the end date to yesterday
          endDate = new Date(today);
          endDate.setDate(today.getDate() - 1);
          startDate = new Date(endDate); // Set start date to same as end date (yesterday)
          break;
    
        case "Last 7 Days":
          // Set the end date to today
          endDate = new Date(today);
          
          // Set the start date to 7 days before the end date (i.e., last week)
          startDate = new Date(endDate);
          startDate.setDate(endDate.getDate() - 7);
          break;
    
        case "Last 30 Days":
          // Set the end date to today
          endDate = new Date(today);
    
          // Set the start date to 30 days before today
          startDate = new Date(today);
          startDate.setDate(today.getDate() - 30);
          break;
    
        case "Custom Range":
          setNewDatePicker(false)
          setShowCalendar(true);
          return; // Custom date logic handled elsewhere
       case "This Month":
            // Set the start date to the first day of the current month
            startDate = new Date(today.getFullYear(), today.getMonth(), 1);
            // Set the end date to today (if today is within the current month)
            endDate = new Date(today);
            break;
      case "Last Month":
            // Set the start date to the first day of the previous month
            startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            // Set the end date to the last day of the previous month
            endDate = new Date(today.getFullYear(), today.getMonth(), 0); // Using day 0 of the current month gives the last day of the previous month
            break;
        default:
          return;
      }
    
      // Create a new date object with updated start and end date
      const normaldate = [{
        startDate: startDate,
        endDate: endDate,
        key: "selection",
      }];
    
      // Update datestate[0] with new startDate and endDate
      setdateState(normaldate);
    
      // Update the timeStamp with formatted start and end dates
      handletimeStamp({
        startDate: formatDateToYMD(startDate),
        endDate: formatDateToYMD(endDate),
        startTime: decodeTimeToISO(value[0]),
        endTime: decodeTimeToISO(value[1]),
      });
    
      setNewDatePicker(false);
    };
    


    const handleDateClick = () => {
        setShowDatePicker(!showDatePicker);
    };
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {

          console.log("Clicked element's id:", event.target.id); // Logs the ID (if any)
          if(event.target.id=='arrow'){
            return
          }
          setNewDatePicker(false);
          setHoverCustomDate(false);
        }
      };
  
      document.addEventListener("mousedown", handleClickOutside);
  
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);
    const dateOnCloseHandler = () => {
     setdateState(storedDate(savedload)) 
     if(savedload.filter_array?.date_filter.start_time){
      setValue([convertTimeToValue(savedload.filter_array?.date_filter.start_time),convertTimeToValue(savedload.filter_array?.date_filter.end_time)])
     }  
        setShowDatePicker(false);
        setShowCalendar(false)
    };
 useEffect(() => {
      if (filteredData && Array.isArray(filteredData)) {
        // Safely extract unique visit types
        SetUniqueVisitType([
          ...new Set(
            filteredData.map((record) => record?.purpose?.toUpperCase() || "")
          ),
        ]);
    
        // Safely extract unique providers
        setUniqueProvider([
          ...new Set(
            filteredData.map((record) => record?.providername?.toUpperCase() || "")
          ),
        ]);
      } else {
        // Reset values if filteredData is invalid
        SetUniqueVisitType([]);
        setUniqueProvider([]);
      }
    }, [filteredData]);
    
    const dateOnCloseHandle=()=>{     
        handletimeStamp({
      startDate:formatDateToYMD(datestate[0].startDate),
      endDate:formatDateToYMD(datestate[0].startDate),
      startTime:decodeTimeToISO(value[0]),
      endTime:decodeTimeToISO(value[1])
     })

     setShowDatePicker(false);
   
    }

    const daterangeCloseHandle=()=>{ 

    handletimeStamp({
    startDate:formatDateToYMD(datestate[0].startDate),
    endDate:formatDateToYMD(datestate[0].endDate),
    startTime:decodeTimeToISO(value[0]),
    endTime:decodeTimeToISO(value[1])
   })

 setShowCalendar(false)
 
  }
    useEffect(()=>{
      setdateState(storedDate(savedload))
  
  },[savedload])


const handledateClear=()=>{
  handletimeStamp({
    startDate:new Date().toISOString().split("T")[0],
    endDate: new Date().toISOString().split("T")[0],
    startTime: decodeTimeToISO(value[0]),
    endTime: decodeTimeToISO(value[1]),
  });
  setShowDatePicker(false);
}



    return (
        <div className=' w-full relative'>
           {mydata.usertype==='BUSINESS'?
           <div className='flex w-full items-center justify-center gap-2'>
              <div onClick={() => changeDate(-1)} className="mx-[6px]" style={{ fontSize: "25px", cursor: "pointer" }}>&lt;</div>
                <div
                    className='p-2 bg-[#FFF] cursor-pointer border w-auto min-w-[60%]'
                    onClick={handleDateClick}
                    style={{
                        borderRadius: "18px",
                        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
                    }}
                >
                    <span className="text-center break-words [font-family:'Poppins-Regular',Helvetica]  text-[#060606] text-sm tracking-[0.14px] leading-[normal]">
                        {formatDate(datestate[0].startDate)}
                    </span>
                </div>
                <div onClick={() => changeDate(1)} className="mx-[6px]" style={{ fontSize: "25px", cursor: "pointer" }}>&gt;</div>
          
            </div>
            :
            
            <div className='w-full  flex flex-wrap gap-4 items-center'>
         
 <div
 className=" p-2 px-2 cursor-pointer border w-full max-w-[200px] flex flex-row flex-wrap  gap-2"
 

  style={{
    borderRadius: "6px",
    border: "1px solid #E5E7EB", // color-grey-91
    background: "#F4F4F5", // color-grey-96
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }}
>
  {/* Formatted Date */}
  <span
  className={`flex gap-4 [font-family:'Poppins-Regular',Helvetica] text-[#060606] ${
    formatDate(datestate[0].startDate) === formatDate(datestate[0].endDate)
      ? 'text-sm'
      : 'text-xs'
  } tracking-[0.14px] leading-[normal]`}
>   {formatDate(datestate[0].startDate) === formatDate(datestate[0].endDate) && (
      <FontAwesomeIcon icon={faChevronLeft} onClick={() => changeDate(-1)} className="text-[#060606]" />
    )}
  {formatDate(datestate[0].startDate) === formatDate(datestate[0].endDate)
    ? formatDate(datestate[0].startDate)
    : `${formatDate(datestate[0].startDate)} - ${formatDate(datestate[0].endDate)}`}
      {formatDate(datestate[0].startDate) === formatDate(datestate[0].endDate) && (
      <FontAwesomeIcon icon={faChevronRight} onClick={() => changeDate(1)} className="text-[#060606]" />
    )}
</span>

<div   
 onClick={() =>{
    if(mydata.usertype==='PRO'){
      setShowCalendar(true);
      return
    }
    setNewDatePicker(!newdatepicker)
  } } className="ml-2">
    <FontAwesomeIcon icon={faCalendar} />
  </div>

</div>

  {mydata.usertype === 'PRO' ? (

<div className='cursor-pointer' onClick={()=>{fetchEhr()}}>
<Tooltip title="Sync Appointments">
    <ReplayIcon style={{ color: "#000000" }} />
  </Tooltip>
</div>

) : (
<></>
)}


    <div className='cursor-pointer' onClick={handleFilterClick}>
      <Tooltip title="Filters">
      <FilterAltIcon/>
      </Tooltip>
    </div>


 
</div>

              
              }
{newdatepicker && (
  <div
    ref={dropdownRef}
    className="absolute z-50 w-full bg-white border rounded-lg shadow-lg"
    style={{
      top: "70px",
      right: '0px',
      left: '20px',
      minWidth: "200px",
    }}
  >
    <ul className="space-y-2 p-2">
      {["Today","Yesterday", "Last 7 Days", "Last 30 Days","This Month","Last Month", "Custom Range"].map((item, index) => (
          <li
            key={index}
            className={`cursor-pointer text-start p-2 ${
              disableLi.includes(item) ? "text-gray-300 cursor-not-allowed" : "hover:bg-gray-200"
            }`}
            onClick={() => {
              if (!disableLi.includes(item)) {
                handleDateSelection(item);
              }
            }}
          >
            {item}
          </li>
        
      ))}
    </ul>
    
  </div>
)}
{/* {showCalendar && (

    <div
    className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
    onClick={(e) => {
     
      if (e.target === e.currentTarget) setShowCalendar(false);
    }}
  >
<div 
className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20 bg-white p-4 md:p-2 sm:p-2 rounded-lg shadow-lg">

  <div className='mb-4 flex items-center justify-between'>
    <div className="w-full flex justify-between">
      <div className="[font-family:'Poppins-Medium',Helvetica] font-bold text-black text-base text-center tracking-[0.16px] leading-[normal]">
        Calendar
      </div>
      <button
        className={`p-2 h-6 w-[30%] rounded-[14px] shadow-lg text-[10px] font-semibold flex items-center justify-center transition-colors duration-300 bg-black text-white border border-gray-300`}
      onClick={()=>daterangeCloseHandle()}>Apply</button>

      <div onClick={() => dateOnCloseHandler()}>
        <CloseIcon style={{ color: "#B4B4B4", cursor: "pointer" }} />
      </div>
    </div>
  </div>
  <DateRange
    editableDateInputs={true}
    onChange={(item) => handledateChange([item.selection])}
    moveRangeOnFirstSelection={false}
    ranges={datestate}
    className="text-xs"
  />
 
</div>
</div>
)} */}
{showCalendar && (
  <CalendarModal
    datestate={datestate}
    handledateChange={handledateChange}
    onClose={() => setShowCalendar(false)}
    onApply={daterangeCloseHandle}
  />
)}


   {/* {showFilterModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-10" onClick={filterOnCloseHandler} />
            )}

  
            {showDatePicker && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-10" onClick={dateOnCloseHandler} />
            )} */}
{/* {showFilterModal && (
  <div className="fixed inset-0 flex items-center justify-center z-20 bg-black bg-opacity-30">
    <div className="w-[500px] bg-white p-4 rounded-lg shadow-lg">
  
      <div className='flex justify-between items-center mb-11'>
        <div className="font-bold text-black text-base tracking-[0.16px]">Filters</div>
        <CloseIcon 
          style={{ color: '#B4B4B4', cursor: 'pointer' }} 
          onClick={() => {
            filterOnCloseHandler();
            setSelectedVisits([]);
          }} 
        />
      </div>
      <div className="w-full flex flex-col items-start mb-4">
  <div className="font-semibold text-black text-[14px] mb-2">Patient Status</div>
  <div className='flex flex-col gap-4'>
  {options.map((option) => (
       <label key={option.value} className='flex items-center gap-2 cursor-pointer'>
       <input
         type='radio'
         name='tab'
         value={option.value}
         checked={tab === option.value}
         onChange={() => handleTabs(option.value)}
         className='cursor-pointer accent-black'
       />
       <span>{option.label}</span>
     </label>
      ))}
    </div>
  
</div>

      <div class="h-[1px] bg-[#E4E4E7] mb-2 w-full"></div>
   
      {mydata.usertype==='PRO'?<>
      <div className="w-full flex flex-col items-start mb-4">
        <div className="font-semibold text-black text-[14px]">Provider</div>
        {originaldata.length ? (
          <div className="flex flex-wrap gap-2 mt-4">
            {uniqueProvider.map((provider, index) => (
              <button
                key={index}
                onClick={() => handleProviderClick(provider)}
                className={`min-w-24 p-2 h-8 shadow-lg rounded-[14px] text-[10px] font-semibold flex items-center justify-center transition-colors duration-300 ${
                  selectedProviders.includes(provider)
                    ? 'bg-[#A2C6FD] text-white'
                    : 'bg-white text-black border border-gray-300'
                }`}
              >
                {provider}
              </button>
            ))}
          </div>
        ) : (
          <>No Providers Available</>
        )}
      </div>
      <div class="h-[1px] bg-[#E4E4E7] mb-2 w-full"></div>


   
      <div className="w-full flex flex-col items-start">
        <div className="font-semibold text-black text-[14px]">Visit Type</div>
        {originaldata.length ? (
          <div className="flex flex-wrap gap-2 mt-4">
            {uniqueVisitType.map((visit, index) => (
              <button
                key={index}
                onClick={() => handleVisitClick(visit)}
                className={`p-2 h-8 rounded-[14px] shadow-lg text-[10px] font-semibold flex items-center justify-center transition-colors duration-300 ${
                  selectedVisits.includes(visit)
                    ? 'bg-[#A2C6FD] text-white'
                    : 'bg-white text-black border border-gray-300'
                }`}
              >
                {visit}
              </button>
            ))}
          </div>
        ) : (
          <>No Visits Available</>
        )}
      </div>
      <div class="h-[1px] bg-[#E4E4E7] mt-2 w-full"></div></>:<></>}
  
      <div className='flex mt-5 items-center justify-evenly w-full'>
        {originaldata.length ? (
          <>
            <button
              className="p-2 h-8 w-[30%] rounded-[14px] shadow-lg text-[10px] font-semibold bg-white text-black border border-gray-300"
              onClick={() => {
                if(mydata.usertype!=='PRO'){
                  setShowFilterModal(false);
                  return
                }
                handleRecordType(selectedProviders, selectedVisits, showFilterModal);
                filterOnCloseHandler();
              }}
            >
              Apply
            </button>
            <button
              className="p-2 h-8 w-[30%] rounded-[14px] shadow-lg text-[10px] font-semibold bg-white text-black border border-gray-300"
              onClick={() => {
              
                  handleTabs('ALL')
               
                handleClear();
                filterOnCloseHandler();
              }}
            >
              Clear
            </button>
          </>
        ) : null}
      </div>
    </div>
  </div>
)} */}
<FiltersModal
  show={showFilterModal}
  onClose={() => setShowFilterModal(false)}
  handleTabs={handleTabs}
  tab={tab}
  options={options}
  mydata={mydata}
  originaldata={originaldata}
  uniqueProvider={uniqueProvider}
  uniqueVisitType={uniqueVisitType}
  selectedProviders={selectedProviders}
  selectedVisits={selectedVisits}
  handleProviderClick={handleProviderClick}
  handleVisitClick={handleVisitClick}
  handleRecordType={handleRecordType}
  handleClear={handleClear}
  filterOnCloseHandler={filterOnCloseHandler}
  setSelectedVisits={setSelectedVisits}
/>

            {/* Modal for date picker */}
            {showDatePicker && (
<div
  className="sm:absolute fixed top-[43%] sm:top-[80%] sm:left-0 left-1/2 transform sm:translate-x-0 -translate-x-1/2 z-50 bg-white p-4 rounded-lg shadow-lg  max-w-[300px]"
>
             

                    <Box mt={2}>
                      
                        <Calendar
                            onChange={(value)=>handleOnDateSelector(value)} 
                            value={datestate[0].startDate} // Show selected date
                            className="text-decoration-line: none" // Add custom class if needed
                       
                        />
                    </Box>

                
                </div>
            )}

<div className="flex flex-wrap gap-4 py-2 items-center relative">
        {(selectedProviders.length || selectedVisits.length) ? <>
          <Stack direction="row" spacing={1} className="flex flex-wrap ">
            {/* providers */}
            {selectedProviders.length ? <>
              {selectedProviders?.map((item, index) => {
                return (<>
                  <Chip label={item}
                    onDelete={() => { handleproviderchipDelete(item) }}
                    style={{
                      margin: "2px",
                      color: "#09090B",
                      fontStyle: "normal",
                      background: "#E5E7EB",
                      height: "20px",
                      fontSize: "12px",
                      display:"flex",
                      alignItems:"center",
                      justifyContent: "center",
                    }}
                    deleteIcon={<div style={{ color: "white" }}><ClearIcon style={{ fontSize: "18px",marginBottom:"4px" ,color:'#09090B'}}  /></div>}

                  />
                </>)
              })}

            </> : <></>}
            {selectedVisits.length ? <>
              {selectedVisits?.map((item, index) => {
                return (<>
                  <Chip
                    label={item}
                    deleteIcon={<div style={{ color: "white" }}><ClearIcon style={{ fontSize: "18px" ,marginBottom:"4px" ,color:'#09090B'}}  /></div>}
                    onDelete={() => { handleVisitschipDelete(item) }}
                    style={{
                      margin: "2px",
                      color: "#09090B",
                      fontStyle: "normal",
                      background: "#E5E7EB",
                      height: "20px",
                      fontSize: "12px",
                    }}
                  />
                </>)
              })}

            </> : <></>}



          </Stack>
        </> : <></>
        }
<Stack
  direction="row"
  spacing={1}
  sx={{
    flexWrap: 'wrap',

    overflow: 'hidden', // Optional: prevents overflow
  }}
>
  {storedDate(savedload)?.[0] && (() => {
    const startDate = formatChipDate(storedDate(savedload)[0].startDate);
    const endDate = formatChipDate2(storedDate(savedload)[0].endDate);
    const dateLabel = startDate === endDate ? startDate : `${startDate} - ${endDate}`;

    return startDate ? (
      <Chip
        label={dateLabel}
        onDelete={handleDateChip}
        deleteIcon={
          <div style={{ color: "white" }}>
            <ClearIcon style={{ fontSize: "18px", marginBottom: "4px", color: "#09090B" }} />
          </div>
        }
        style={{
          margin: "2px",
          color: "#09090B",
          fontStyle: "normal",
          background: "#E5E7EB",
          height: "20px",
          fontSize: "12px",
          display: "flex",
          alignItems: "center",
        }}
      />
    ) : null;
  })()}
</Stack>



        {(selectedProviders.length || selectedVisits.length || formatChipDate(storedDate(savedload)[0].startDate)) ?
          <div style={{ color: "#7B7575" }} onClick={() => {

            handleOnclear()
            //handleallreduxclose()
          }}>  <ClearIcon style={{ fontSize: '20px' ,color:'#09090B',marginBottom:"2px"}} />
          </div> : <></>}

          </div>
          
             
        </div>
    );
};

export default Filtersdt;
